import React,{Fragment} from 'react';
import Footer from '../../../../components/common/Footer';
import Section from '../../../../components/common/Section';
import PlainBanner from '../../../../components/common/PlainBanner';
import Head from 'next/head';
import SRList from '../../../../components/tracker/sr-list/SRList';
import SelfServeStyles from '../../../../styles/pages/selfserve.module.scss';
import TrackerStyles from '../../../../styles/modules/components/tracker.module.scss';
import { searchServiceRequests } from '../../../../redux/actions/trackerActions';
import { connect } from 'react-redux';
import { withRouter, NextRouter } from 'next/router';
import InfiniteScroll from '../../../../components/common/InfiniteScroll';
import { trackRequestListViewed } from '../../../../tracking/segment/trackerPage';
import { pageCallSegment } from '../../../../utils/tracking/segmentTracking';

interface TrackerListProps {
    trackerReducer: any,
    searchServiceRequests: (value:any, page:number) => void,
    router: NextRouter,
}

interface State {
    isLoading:boolean,
}

export async function getServerSideProps() {
    return {
      props: {
        pageName: "registration",
      },
    };
  }

class SRSearchResults extends React.Component<TrackerListProps> {
    state:State = {
        isLoading: false,
    }

    onClickTrack = (ref_no:any) => {
        this.props.router.push(`/selfserve/tracker/service-request/${ref_no}`);
    }

    componentDidMount () {
        if (this.props.trackerReducer.search.count === 0) {
            this.props.router.replace(`/selfserve/tracker`);
        }
        let active_sr_id = this.props.trackerReducer?.search?.results.filter((plan) => plan.status=='Open').map((plan)=> plan.ref_no);
        trackRequestListViewed({'no_of_items':this.props.trackerReducer?.search?.count,"active sr ids":active_sr_id})
        pageCallSegment("Track Request List View")
    }
    componentDidUpdate (prevProps) {
        if (prevProps.trackerReducer.search.page !== this.props.trackerReducer.search.page) {
            this.setState({ isLoading: false });
        }
    }
    onBottomHit = () => {
        const { page, value, results } = this.props.trackerReducer.search;
        if (results.length !== 0) {
            this.setState({ isLoading: true });
            this.props.searchServiceRequests(value, page + 1);
        }
    }
    hasMoreData = () => {
        const { count, results } = this.props.trackerReducer.search;
        const hasMoreData = count > results.length;
        if (!hasMoreData) {
        }
        return hasMoreData;
    }

    render() {
        const { trackerReducer } = this.props;
        return (
            <Fragment>
                <Head>
                    <title>Track Service Request</title>
                    <link rel="icon" href="/favicon.ico" />
                </Head>
                <PlainBanner  title="" subtitle="" className={TrackerStyles.tracker_banner}>
                </PlainBanner>
                <Section dataBg="shade-2" style={{paddingTop:'1px',paddingBottom:'100px',position:'relative'}}>
                    <div className="container">
                        <div className={SelfServeStyles.self_serve_parent}>
                            <h3 className={TrackerStyles.main_heading}>Track Service Request</h3>
                            {trackerReducer.search.count > 1 && <h5 className={`${TrackerStyles.secondary_heading} ${TrackerStyles.multiple_found}`}>We Found Multiple Requests, Choose One To Proceed</h5> }
                            {trackerReducer.search.count > 1 &&
                                <InfiniteScroll
                                    onBottomHit={this.onBottomHit}
                                    isLoading={this.state.isLoading}
                                    hasMoreData={this.hasMoreData()}
                                    loadOnMount={false}
                                >
                                    <SRList data={trackerReducer.search.results} onClickTrack={this.onClickTrack} />
                                    <div className={TrackerStyles.blank}></div>
                                </InfiniteScroll>
                            }
                        </div>
                    </div>
                </Section>
            <Footer />
            </Fragment>
    )
    }
}

const mapStateToProps = (state:any) => {
    return {
        trackerReducer: state.trackerReducer,
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
        searchServiceRequests: (value:any, page:number) => dispatch(searchServiceRequests(value, page)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SRSearchResults));
